// NIE / NIF (DNI) validators
const _isNIE = (v) => /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(v);
const _isNIF = (v) => /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]{1}$/i.test(v);

const isValidDni = (value) => {
  const dni = !value ? "" : value; // lowercase is faster

  if (dni.length !== 9 && !_isNIE(dni) && !_isNIF(dni)) {
    return false;
  }

  let f = "xyzXYZ".indexOf(dni[0]) % 3;

  if (f === -1) {
    f = dni[0];
  }

  const i = +(f + dni.slice(1, 8)) % 23;

  return "trwagmyfpdxbnjzsqvhlcket".indexOf(dni[8].toLowerCase()) === i;
};
const dniNormalize = (str) => {
  return str.replace(/[-_\s]/gi, "").toUpperCase();
};
// end dni validators






export const v_required = value => (value || typeof value === 'number' ? undefined : 'Campo obligatorio');
export const v_maxLength = max => value => value && value.length > max ? `Must be ${max} characters or less` : undefined
export const v_minLength = min => value => value && value.length < min ? `Must be ${min} characters or more` : undefined
export const v_arrayMinLength = function(min, value) {
  if (typeof value === 'undefined') {
    return `Por favor selecciona al menos ${min} ${min === 1 ? "opción" : "opciones"}`;
  }
  return value && value.length < min ? `Por favor selecciona al menos ${min} ${min === 1 ? "opción" : "opciones"}` : undefined;
}
export const v_policy = function(min, value) {
  if (typeof value === 'undefined') {
    return 'Campo obligatorio';
  }
  return value && value.length < min ? `Por favor selecciona al menos ${min} opciones` : undefined;
}

export const v_number = value => isNaN(Number(value)) ? 'Tiene que ser un número' : undefined
export const v_nifNie = (value) => {
  if (typeof value === 'undefined') {
    return 'DNI inválido';
  }
  return !isValidDni(dniNormalize(value)) ? 'DNI inválido' : undefined
}

export const v_height = value => isNaN(Number(value)) || String(value).match(/^([0-9]{1}\.[0-9]{2})$/ig) === null ? 'Tiene que ser un número de forma "n.nn". Ejemplo: 1.85' : undefined
export const v_minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined
export const v_email = value =>
  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Dirección de correo electrónico no válida'
    : undefined
export const v_tooYoung = value =>
  value && value < 13
    ? 'You do not meet the minimum age requirement!'
    : undefined
export const v_aol = value =>
  value && /.+@aol\.com/.test(value)
    ? 'Really? You still use AOL for your email?'
    : undefined
export const v_alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined
export const v_phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined



// WEBPACK FOOTER //
// ./src/helpers/form/validators.js